import { RoutePaths } from "@ryde/shared";

const SESSION_GATE_EXCLUDED_PATHS = [
  RoutePaths.LOGIN,
  "/reset-password",
  RoutePaths.OAUTH_CONSENT,
  RoutePaths.MCP_CONNECTOR_ACTION,
] as const;

export const getSessionGatePathname = (): string => {
  const hashPath = window.location.hash.replace(/^#/, "").split("?")[0];
  return hashPath || "/";
};

export const shouldApplySessionGateLoader = (pathname: string): boolean =>
  !SESSION_GATE_EXCLUDED_PATHS.some(
    excluded => pathname === excluded || pathname.startsWith(`${excluded}/`),
  );

export const shouldOpenSessionGateOnCompanyChange = ({
  isLoggedIn,
  previousCompanyId,
  companyId,
  isAdminApp,
}: {
  isLoggedIn: boolean;
  previousCompanyId: number | undefined;
  companyId: number | undefined;
  isAdminApp: boolean;
}): boolean =>
  Boolean(
    isLoggedIn &&
    !isAdminApp &&
    previousCompanyId &&
    companyId &&
    previousCompanyId !== companyId,
  );

export const shouldHideSessionOverlayImmediately = ({
  isLoggedIn,
  isDialogReady,
}: {
  isLoggedIn: boolean;
  isDialogReady: boolean;
}): boolean => !isLoggedIn || isDialogReady;

export const shouldHoldSessionGateForUnreadyShell = ({
  isShellReady,
}: {
  isShellReady: boolean;
}): boolean => !isShellReady;

export const shouldLeaveSessionOverlayLeftBar = (): boolean => false;

export const shouldShowApiBackdrop = ({
  isBlockingFullscreenLoader,
  isSessionOverlayVisible,
  isDialogReady,
}: {
  isBlockingFullscreenLoader: boolean;
  isSessionOverlayVisible: boolean;
  isDialogReady: boolean;
}): boolean =>
  isBlockingFullscreenLoader && !isSessionOverlayVisible && !isDialogReady;
